export * from './baBackTop.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baBackTop/index.ts